// extracted by mini-css-extract-plugin
export default {"form":"MUHsa","focused":"gOc1S","icon":"sM9Qx","wrapper":"hxDYc","button":"vyOQn"};